import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface WebsocketState {
    connectionId?: string;
}

const initialState: WebsocketState = {
    connectionId: undefined,
};

const websocketSlice = createSlice({
    name: 'websocket',
    initialState,
    reducers: {
        setConnectionId(state, action: PayloadAction<string>) {
            state.connectionId = action.payload;
        },
    },
});

export const { setConnectionId } = websocketSlice.actions;
export default websocketSlice.reducer;
